<template>
  <div class="navbody">
    <!--<div class="background"></div>
    <nav class="navbar">
      <img class="navbar-logo" src="./assets/logo.png" />
      <input type="text" placeholder="Search" class="navbar-search" />
    </nav>-->
    <button class="navbar-burger" @click="toggleMenu"></button>
    <nav class="menu">
      <a @click="profile" style="animation-delay: 0.1s;color: #fff;cursor:pointer;">Votre profil</a>
      <a @click="commandes" style="animation-delay: 0.2s;color: #fff;cursor:pointer;">Vos commandes</a>
      <a @click="about" style="animation-delay: 0.3s;color: #fff;cursor:pointer;">Qui sommes-nous</a>
      <a @click="profile" style="animation-delay: 0.4s;color: #fff;cursor:pointer;">Conditions générales</a>
      <a @click="participants" style="animation-delay: 0.4s;color: #fff;cursor:pointer;">Participants</a>
      <a @click="logout" style="animation-delay: 0.5s;color: #fff;cursor:pointer;" v-if="connected">Déconnexion</a>
      
    </nav>
    <notifications group="logout-success" position="top center" style="z-index:999999;" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: 'Navmenu',
  props: ['profile', 'commandes', 'conditions', 'about',"aboutus","participants"],
  data(){
    return{
      connected:false,
    }
  },
  computed: {
    ...mapGetters(),
    acc_token(){
      return localStorage.getItem("accessToken");
    }
  },
  watch:{
    acc_token: function () {
      if (this.acc_token) {
        this.connected = true;
      } else this.connected = false;
      return this.connected;
    },
  },
  methods: {
    ...mapMutations(["isConnected"]),

    toggleMenu() {
      document.body.classList.toggle("open");
    },
    closeallmodals() {
      $('.modal').on('show.bs.modal', function () {
        $('.modal').not($(this)).each(function () {
          $(this).modal('hide');
        });
      });
    },
    logout() {
      localStorage.setItem("accessToken", "")
      this.$notify({
        group: "logout-success",
        type: "success",
        title: "Réussi",
        text:
          "Vous êtes déconnecté"
      });
      setTimeout(() => {
        // this.$router.push({ name: 'Login' })
        window.location.reload()
      }, 200)
    }
  },
  mounted() {
    this.isConnected()
    console.log('TTTOOOKKKEENN????' + this.connected)
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

button {
  border: 0;
  padding: 0;
  /* background: #f05d2e; */
  background: transparent;
  box-shadow: none;
  cursor: pointer;
}

.navbar,
.navbar-burger,
.menu,
.background {
  position: fixed;
  /* position: fixed; */
}

/* 
.background {
  z-index: 1;
  top: -10%;
  left: -10%;
  width: 120%;
  height: 120%;
  background-image: url("assets/bg.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  transition: 0.5s;
} */

body.open .background {
  filter: blur(20px);
}

/* 
.navbar {
  z-index: 1;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 72px;
  padding-left: 20px;
  padding-right: 72px;
  background: #19191c;
  color: #f9f9f9;
} 

.navbar > button {
  font-size: 28px;
}

.navbar-logo {
  height: 25px;
}
*/

.navbar-burger {
  z-index: 9999;
  top: 10px;
  right: 0;
  display: grid;
  place-items: center;
  width: 50px;
  height: 50px;
  background-image: url("../../../public/illustrations/menu.png");
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 10px 0 0 10px;
  background-color: #f05d2ecc;
  /* opacity: 1; */
}

body.open .navbar-burger {
  background-image: url("../../../public/illustrations/close.svg");
  z-index: 999991;
}

/* 
.navbar-search {
  border: 0;
  height: 40px;
  background: #2f3339 url("assets/search.svg");
  background-repeat: no-repeat;
  background-position: 10px 50%;
  border: 0;
  border-radius: 6px;
  padding-left: 36px;
  width: 180px;
  font-size: 16px;
  font-family: "Euclid Circular A";
} 

.navbar-search::placeholder {
  color: #a7a7a7;
}*/

.menu {
  z-index: 99999;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  width: 100%;
  height: 100%;
  /* background: rgba(0, 0, 0, 0.8); */
  background: #f05d2ecc;
  /* background: #f05d2e; */
  opacity: 0;
  visibility: hidden;
  transition: 0.5s;
}

body.open .menu {
  opacity: 1;
  visibility: visible;
}

.menu a {
  color: #f9f9f9;
  font-size: 22px;
  text-decoration: none;
}

body.open .menu a {
  animation: appear 0.3s both;
}

@keyframes appear {
  0% {
    opacity: 0;
    translate: 0 50px;
  }

  100% {
    opacity: 1;
  }
}
</style>